import { Address } from '@/types/address';

// Required to use fallback data on ERP-addresses missing properties (temporary)
export const formattedAddress = (address: Address) => {
  if (!address.recipientName) address.recipientName = 'Mottagarnamn saknas';
  if (!address.address2) address.address2 = 'Adress saknas';
  return address;
};
export const formatZipCode = (zipCode: string) => zipCode?.replace(' ', '');
